import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { company_name, facebook_page_url, instagram_page_url, twitter_page_url, menu, pinterest_page_url } from "../../constants/constants";
import { setSideBarVisibility } from "../../store/actions";

const current_year = moment().format("YYYY");

function Sidebar(props) {
  const dispatch = useDispatch();
  const sideBarVisibility = useSelector((state) => state.sideBarVisibility);

  let sideBarVisibilityClass = "sidenav canvas-sidebar bg-white";
  sideBarVisibilityClass += sideBarVisibility ? " show" : "";

  const sidebarHandler = (e) => {
    e.preventDefault();
    console.log("sidebarHandler");
    dispatch(setSideBarVisibility(!sideBarVisibility));
  };

  return (
    <>
      <div className={sideBarVisibilityClass} onClick={sidebarHandler}>
        <div className="canvas-overlay"></div>
        <div className="pt-5 pb-7 card border-0 h-100">
          <div className="d-flex align-items-center card-header border-0 py-0 pl-8 pr-7 mb-9 bg-transparent">
            <Link to="/" className="d-block w-130">
              <img src="/luminit-logo-1.png" alt={company_name} />
            </Link>
            <span className="canvas-close d-inline-block text-right fs-24 ml-auto lh-1 text-primary">
              <i className="fal fa-times"></i>
            </span>
          </div>
          <div className="overflow-y-auto pb-6 pl-8 pr-7 card-body pt-0">
            <ul className="navbar-nav main-menu px-0">
              {menu.map((element, index) => {
                return (
                  <>
                    <li className="nav-item dropdown py-1 px-0" key={index}>
                      <Link key={element.slug} to={element.to} className="nav-link dropdown-toggle p-0" data-page={element.slug}>
                        {element.title}
                      </Link>
                      {element.children && (
                        <div data-page={element.slug} className="dropdown-menu p-0 dropdown-menu-listing x-animated x-fadeInUp">
                          {element.children.nodes.map((node_element, index) => {
                            return (
                              <>
                                <div className="dropdown-item" key={index}>
                                  <Link key={node_element.to} to={node_element.to} className="dropdown-link">
                                    {node_element.title}
                                  </Link>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      )}
                    </li>
                  </>
                );
              })}
            </ul>
          </div>
          <div className="card-footer bg-transparent border-0 mt-auto pl-8 pr-7 pb-0 pt-4">
            <ul className="list-inline text-lg-right mb-2">
              <li className="list-inline-item mr-4">
                <a href={facebook_page_url} target="_blank" rel="noreferrer" className="fs-20">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="list-inline-item mr-4">
                <a href={instagram_page_url} target="_blank" rel="noreferrer" className="fs-20">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
            <p className="mb-0 text-gray text-lg-right font-weight-500">
              © {current_year} {company_name}.
              <br />
              Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
